export default __webpack_public_path__ + "static/media/T_65_desktop.60c0eaef.jpg";